module.exports = __webpack_public_path__ + "./img-joy_88200ac80315d8dbf756a0160ad3fc89.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2018/img-joy.png
// module id = 466
// module chunks = 0